import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const TAB_KEYS = ["forex", "indices", "commodities", "shares"];

export const MarketsOverview = () => {
  const { t } = useLang();
  const [tab, setTab] = useState("forex");
  const rows = t.markets.data[tab];

  return (
    <section id="markets" data-testid="markets-section" className="bg-[#FAF9F6] py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Overline>{t.markets.overline}</Overline>
          <div className="mt-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 max-w-xl">
              {t.markets.title}
            </h2>
            <p className="text-base text-slate-600 leading-relaxed max-w-md">{t.markets.lead}</p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-wrap gap-2" data-testid="markets-tabs">
            {TAB_KEYS.map((k) => (
              <button
                key={k}
                data-testid={`markets-tab-${k}`}
                onClick={() => setTab(k)}
                className={`px-6 py-2.5 rounded-full text-sm transition-all duration-300 border ${
                  tab === k
                    ? "bg-slate-900 text-white border-slate-900"
                    : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
                }`}
              >
                {t.markets.tabs[k]}
              </button>
            ))}
          </div>

          <div className="mt-8 bg-white border border-slate-200 overflow-hidden">
            <div className="grid grid-cols-[1.4fr_1fr_1fr] px-6 lg:px-10 py-4 border-b border-slate-200 bg-slate-50/60">
              {[t.markets.colInstrument, t.markets.colSession, t.markets.colType].map((h) => (
                <span key={h} className="text-[11px] font-mono uppercase tracking-[0.2em] text-slate-500">{h}</span>
              ))}
            </div>
            <AnimatePresence mode="wait">
              <motion.div
                key={tab}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.35 }}
                data-testid={`markets-table-${tab}`}
              >
                {rows.map((r, i) => (
                  <div
                    key={i}
                    className="grid grid-cols-[1.4fr_1fr_1fr] px-6 lg:px-10 py-5 border-b border-slate-100 last:border-0 hover:bg-[#FAF9F6] transition-colors duration-300"
                  >
                    <span className="font-medium text-slate-900 text-sm lg:text-base">{r[0]}</span>
                    <span className="text-sm text-slate-500 font-mono">{r[1]}</span>
                    <span className="text-sm text-slate-600">
                      <span className="inline-block px-3 py-1 rounded-full bg-slate-100 text-xs">{r[2]}</span>
                    </span>
                  </div>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>
          <p className="mt-4 text-xs text-slate-400 font-mono">{t.markets.note}</p>
        </Reveal>
      </div>
    </section>
  );
};
